// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.openedge.OpenEdgeTransportKeysResponse */
/* istanbul ignore next */
@GandalfModel
export class OpenEdgeTransportKeysResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	errorCode!: string | null;

	@GandalfProperty({ designType: String })
	errorMessage!: string | null;

	@GandalfProperty({ designType: String })
	referenceIdentifier!: string | null;

	@GandalfProperty({ designType: String })
	transportKey!: string | null;

	@GandalfProperty({ designType: String })
	validationKey!: string | null;

}
